module.exports = __webpack_public_path__ + "static/media/styled_components_logo.3745d5de.png";